document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('gift-card-balance-check');
  const DISPLAY_IDS = ['gift-card-balance', 'gift-card-not-found', 'gift-card-error'];

  if (form) {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const formData = new FormData(form);
      const cardNumber = formData.get('gift-card-number').replace(/\s/g, '');
      const cardPin = formData.get('gift-card-pin-number');
      const button = form.querySelector('button[type="submit"]');

      button.disabled = true;
      button.classList.add('loading');

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ cardNumber, cardPin }),
        });

        const result = await response.json();

        if (response.status === 404) {
          toggleDisplay('gift-card-not-found', true);
        } else {
          showBalanceDisplay(true, result?.balances[0]?.amount || 0);
        }
      } catch (error) {
        console.error('Error checking gift card balance:', error);
        toggleDisplay('gift-card-error', true);
      } finally {
        button.disabled = false;
        button.classList.remove('loading');
      }
    });
  }

  /**
   * Show or hide the balance display
   * @param {boolean} isVisible - Whether to show or hide the balance display
   * @param {number} balance - The balance amount to display
   */
  function showBalanceDisplay(isVisible, balance) {
    const balanceAmountElements = document.querySelectorAll('.gift-card-balance-amount');
    if (!balanceAmountElements) return;

    if (isVisible) {
      balanceAmountElements.forEach((element) => (element.textContent = balance));
      toggleDisplay('gift-card-balance', true);
    } else {
      toggleDisplay('gift-card-balance', false);
    }
  }

  /**
   * Show or hide a display element while hiding others
   * @param {string} elementId - The ID of the element to show/hide
   * @param {boolean} isVisible - Whether to show or hide the element
   */
  function toggleDisplay(elementId, isVisible) {
    const element = document.getElementById(elementId);
    if (!element) return;

    if (isVisible) {
      // Hide all other displays
      DISPLAY_IDS.forEach((id) => {
        if (id !== elementId) {
          document.getElementById(id)?.classList.add('hidden');
        }
      });
      element.classList.remove('hidden');
    } else {
      element.classList.add('hidden');
    }
  }
});
